import * as React from 'react';
import AnimatedBorder from '~/customization/Common/AnimatedBorder/AnimatedBorder';
import { BUNDLE_DECORATION } from '~/types/bundle';

interface IBundleDecoration {
    children: React.ReactChild | React.ReactChild[];
    bundle: IBundle;
}

const BundleDecoration = ({ children, bundle }: IBundleDecoration) => {
    const { decoration } = bundle;

    if (decoration.includes(BUNDLE_DECORATION.ANIMATE_BORDER)) {
        return <AnimatedBorder>{children}</AnimatedBorder>;
    }

    return <>{children}</>;
};

export default BundleDecoration;
